module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7de2b48b8826dae7850c0d62c5425896.png";